import { render, staticRenderFns } from "./contentCourseLectureMove.vue?vue&type=template&id=6053efbb&"
import script from "./contentCourseLectureMove.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports